@if (capabilities.database) {
<div class="main bg-light">
  <div class="container p-3 d-flex flex-column gap-3">
    <section class="card p-3 shadow-sm">
      <h1 class="h4">Subscription and usage</h1>
      @if (details) {
        <p>{{ details.tier | titlecase }} plan · {{ details.status | titlecase }}</p>
      }
      <p class="mb-0">Billing is managed outside Kartorium. Contact your organization administrator or
        <a href="mailto:support@kartorium.com">support@kartorium.com</a> to request changes to your plan or allowances.</p>
    </section>
    <section class="card p-3 shadow-sm">
      <h2 class="h5">Usage overview</h2>
      @for (item of usageStats; track item.name) {
        <div class="d-flex flex-wrap justify-content-between gap-2 py-2 border-bottom">
          <span>{{ item.name | titlecase }}</span>
          <span>{{ item.used | number }} / {{ item.limit | number }}</span>
        </div>
      }
    </section>
  </div>
</div>


} @else if (capabilities.legacyStripe) {
<div class="main bg-light">
  <div class="container p-3 d-flex flex-column gap-3">
    <!-- Subscription Summary & Billing Actions -->
    <div class="d-flex justify-content-between align-items-center">
      @if (inFreeTier) {
        <shared-upgrade-tier-banner></shared-upgrade-tier-banner>
      }
      @if (!inFreeTier) {
        <div class="card p-3 bg-light bg-gradient shadow-sm">
          <span> {{ details.tier | titlecase }} Plan - Next Invoice on {{ billingPeriodEnd | date }} </span>
        </div>
      }

      @if (hasUserAdminAccess && !inFreeTier) {
        <div class="d-flex gap-3">
          <button class="btn btn-primary d-flex gap-2 align-items-center p-2"
            (click)="openEditSubscriptionPanel()">
            <span>Manage Subscription</span>
            <i class="fa fa-pen-to-square"></i>
          </button>
          <button class="btn btn-outline-secondary d-flex gap-2 align-items-center p-2"
            (click)="openBillingPortal()">
            @if (isOpening) {
              <span class="spinner-border spinner-border-sm" role="status"
              aria-hidden="true"></span>
            }
            <span>Billing Portal</span>
            <i class="fa fa-credit-card"></i>
          </button>
        </div>
      }
    </div>

    <!-- Subscription Usage Overview -->
    <div class="row">
      <div class="col-6">
        <div class="card p-3 shadow-sm">
          <h5 class="fw-bold">Usage Overview</h5>
          @for (item of usageStats; track item) {
            <div class="mb-3">
              <div class="d-flex justify-content-between align-items-center">
                <span class="fw-semibold">{{ item.name | titlecase }}</span>
                            <span class="fw-bold" [ngClass]="{
                                  'text-muted': (item.used / item.limit) < 0.75,
                                  'text-warning': (item.used / item.limit) >= 0.75 && (item.used / item.limit) < 1,
                                  'text-danger': (item.used / item.limit) >= 1
                              }">
                  {{ item.used | number }} / {{ item.limit | number }}
                  ({{ (item.used / item.limit * 100) | number:'1.0-0' }}%)
                </span>
              </div>
              <div class="progress mt-1">
                            <div class="progress-bar progress-bar-animated bg-opacity-75" role="progressbar" [ngClass]="{
                                  'bg-success': (item.used / item.limit) < 0.75,
                                  'bg-warning': (item.used / item.limit) >= 0.75 && (item.used / item.limit) < 1,
                                  'bg-danger': (item.used / item.limit) >= 1
                              }" [style.width]="(item.used / item.limit) * 100 + '%'">
                </div>
              </div>
              @if ((item.used / item.limit) >= 1) {
                <div class="mt-1 small d-flex align-items-center">
                  <i class="fa fa-exclamation-triangle text-danger"></i>
                  <span class="ms-2 text-danger">
                    Limit Reached!
                  </span>
                  @if (!inFreeTier) {
                    <button class="btn btn-sm btn-outline-primary ms-2"
                      (click)="openEditSubscriptionPanel()">
                      Upgrade {{ item.name | titlecase }}
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>

      @if (inProTier) {
        <div class="col-6">
          <div class="card p-3 shadow-sm">
            <h5 class="fw-bold">Recent Invoices</h5>
            @if (invoices.length > 0) {
              <div>
                <ul class="list-group list-group-flush">
                  @for (invoice of invoices; track invoice) {
                    <li class="list-group-item d-flex justify-content-between">
                      <span>{{ invoice.created * 1000 | date }} - {{ invoice.amount_due / 100 | currency: invoice.currency.toUpperCase() }}</span>
                      <a [href]="invoice.hosted_invoice_url" target="_blank" class="btn btn-sm btn-outline-primary">View</a>
                    </li>
                  }
                </ul>
              </div>
            } @else {
              <p class="text-muted">No invoices available.</p>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Toasts -->
  <div class="toast-container d-flex flex-column m-3">
    <shared-toast-container></shared-toast-container>
  </div>
</div>

<billing-right-panel></billing-right-panel>
}
